module.exports = __webpack_public_path__ + "static/media/Logo.e39aa3b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/Logo.svg
// module id = 387
// module chunks = 0